import { render, staticRenderFns } from "./NezasaImportRedirect.vue?vue&type=template&id=c7fef2f6"
import script from "./NezasaImportRedirect.vue?vue&type=script&lang=js"
export * from "./NezasaImportRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports